<div class="page-header border-bottom"><h3>Create Account</h3></div>
<div class="container">
    <div class="card card-body border bg-light mb-3">
        <div class="row col">
            <i class="modus-icons" style="font-size: 1.2em; vertical-align: 2px;">info</i> Passwords must be at least 12 characters long, and must contain at least 3 of the following: lowercase letters, uppercase letters, numbers, and special characters.
        </div>
    </div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
                <div *ngIf="showError" class="alert alert-danger fade in">
                    {{ failureMessage() }}
                </div>
                <form (ngSubmit)="createAccount()" autocomplete="off">
                    <div class="form-group inner-addon right-addon">
                        <i class="oi oi-minus" *ngIf="capOn" style="z-index: 5; margin-top: 34px; font-size: 0.8em; margin-right: 2.0px "></i>
                        <i *ngIf="capOn" class="oi oi-chevron-top" style="z-index: 5; margin-top: 24px; font-size: 1.0em; margin-right: 1.2px "></i>
                        <label for="newPassword" class="fw-semibold"><strong>Password</strong></label>
                        <input type="password"
                               class="form-control"
                               id="newPassword"
                               [(ngModel)]="formData().newPassword"
                               (ngModelChange)="updateFormField('newPassword', $event)"
                               name="newPassword"
                               placeholder="Password"
                               autocomplete="off"
                               (blur)="onNewPasswordBlur()" />
                        <i *ngIf="capOn">Warning: CAPS Lock is on!</i>
                    </div>
                    <div class="form-group inner-addon right-addon"
                         [ngClass]="{ 'has-error has-feedback':(newPasswordTouched || formData().confirmPassword) && !passwordsMatch() }">
                        <i class="modus-icons" style="color: red; z-index: 5; margin-top: 24px;font-size:1.3em" *ngIf="(newPasswordTouched || formData().confirmPassword) && !passwordsMatch()">close</i>
                        <i class="oi oi-minus" *ngIf="capOn" style="z-index: 5; margin-top: 34px; font-size: 0.8em; margin-right: 2.4px "></i>
                        <i *ngIf="capOn && !((newPasswordTouched || formData().confirmPassword) && !passwordsMatch())" class="oi oi-chevron-top" style="z-index: 5; margin-top: 24px; font-size: 1.0em; margin-right: 1.2px "></i>
                        <label for="confirmPassword" class="fw-semibold"><strong>Confirm Password</strong></label>
                        <input type="password"
                               class="form-control"
                               id="confirmPassword"S
                               [ngClass]="{ 'is-invalid': (newPasswordTouched || formData().confirmPassword) && !passwordsMatch() }"
                               [(ngModel)]="formData().confirmPassword"
                               (ngModelChange)="updateFormField('confirmPassword', $event)"
                               name="confirmPassword"
                               placeholder="Confirm new password"
                               autocomplete="off"
                               (blur)="clearErrors()" />
                        <i *ngIf="capOn">Warning: CAPS Lock is on!</i>
                    </div>
                    <button type="submit" class="btn btn-primary" [disabled]="!passwordsMatch() || !passwordsValid() || creatingAccount()">Submit</button>
                </form>
            </div>
        </div>
    </div>
</div>
